module.exports = __webpack_public_path__ + "img/Simpli.fi.03dbfee3.png";